import { render, staticRenderFns } from "./editModel.vue?vue&type=template&id=92a8d01e&scoped=true"
import script from "./editModel.vue?vue&type=script&lang=js"
export * from "./editModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a8d01e",
  null
  
)

export default component.exports